export const getCookieKeyForLorawan = (email = 'unknown') => `lorawan-integration-${email}`;

export const getCookiesLorawanIntegration = ( integration: string, email?: string) => {
  return {
    key: getCookieKeyForLorawan(email),
    value: integration
  };
};
